import { prefix } from "../../../core/design-tokens/meta";
import { actions, reducers, createStore, renderState } from "../../../core/js/state-machine";
import eventDispatcher from "../../../core/js/state-machine/events";
import { toArray } from "../../../core/js/utilities";
import { chevronDown } from "../../../core/js/helpers/built-in-icons";
import {
    componentName,
    views,
    eventMap,
    defaultProps,
} from "../../../core/components/side-nav/side-nav-group";
import validateInitialization from "../../../core/js/helpers/validate-initialization";

const validateHTML = (element) => {
    const trigger = toArray(element.children).filter((ele) => {
        return ele.tagName === "BUTTON";
    })[0];
    const subMenu = toArray(element.getElementsByTagName("ul"))[0];

    return !!trigger && !!subMenu;
};

const SideNavGroup = (element, props = {}) => {
    const [success, mergedProps] = validateInitialization({
        componentName,
        defaultProps,
        element,
        eventMap,
        props,
        validateHTML,
        views,
    });
    if (!success) return;

    /**
     * When our component is clicked to expand/collapse, we need to do some checking on the parent
     * sidenav if we should also toggle it open (was collapsed).
     * @param {Event} event
     */
    const handClick = (event) => {
        event.preventDefault();
        if (toggleStore.getState() === false) toggleStore.dispatch(actions.expand());
        expandStore.dispatch(actions.toggle());
    };

    /**
     * Append an Icon (currently chevron) to each Group of the side-nav in order to show the user
     * open/close animations on click.
     * @returns
     */
    const addGroupToggleIcon = () => {
        // If we already have an SVG - don't add one.
        if (trigger.lastChild.nodeName === "svg") return;

        // For each button add an svg.
        trigger.insertAdjacentHTML(
            "beforeend",
            chevronDown({ class: `${prefix}side-nav__group__chevron` })
        );
    };

    /**
     * When our component recieves new state - we need to render our view properly.
     * @param {boolean} shouldExpand
     */
    const handleStateChange = (shouldExpand) => {
        renderState(shouldExpand ? views.trigger.expanded : views.trigger.collapsed, trigger);
        renderState(shouldExpand ? views.target.expanded : views.target.collapsed, subMenu);
        const eventName = shouldExpand ? actions.expand() : actions.collapse();
        eventDispatcher(eventMap[eventName.type], element);
    };

    const dispose = () => {
        trigger.removeEventListener("click", handClick);
    };

    const trigger = toArray(element.children).filter((ele) => {
        return ele.tagName === "BUTTON";
    })[0];
    const subMenu = toArray(element.getElementsByTagName("ul"))[0];

    const { toggleStore } = mergedProps.store;

    const initialState = false;
    const expandStore = createStore(reducers.boolReducer, initialState);

    expandStore.subscribe(handleStateChange);

    trigger.addEventListener("click", handClick);

    // Add our chevron to the component.
    addGroupToggleIcon();

    const api = {
        element,
        dispose,
        open: () => {
            expandStore.dispatch(actions.expand());
        },
        close: () => {
            expandStore.dispatch(actions.collapse());
        },
    };

    // Assign ourselves to the element.
    element[componentName] = api;

    // Return ourselves incase we are captured in js.
    return api;
};

export default SideNavGroup;
